import { FC, useRef } from "react";
import { Box } from "@mui/material";
import {
    Modal,
    ModalTitle,
    ModalContent,
    ModalActions,
    Button,
    LoadingButton,
    RequestMessage,
} from "ui";
import { useDispatch } from "react-redux";
import { modalHide } from "app/App/actions";
import GastroPayForm from "../forms/GastroPayForm";
import { TGastroPayModel } from "../types/TGastroPayModel";
import useRequest from "api/useRequest";
import { orderLocationModulesGastroPayConfigure } from "app/Order/Locations/actions";
import { AxiosResponse } from "axios";

type TGastroPayActivateModal = {
    locationId: number;
    onClose: Function;
};

const GastroPayActivateModal: FC<TGastroPayActivateModal> = ({
    locationId,
    onClose,
}) => {
    const dispatch = useDispatch();
    const formRef = useRef<any>();
    const { errors, isLoading, message, request, status } = useRequest();

    const handleClose = () => {
        dispatch(modalHide("GastroPayActivateModal"));
    };

    const handleSubmit = (data: TGastroPayModel) => {
        request(
            orderLocationModulesGastroPayConfigure(
                locationId,
                data,
                (response: AxiosResponse) => {
                    if (response.status < 300) {
                        handleClose();
                        onClose();
                    }
                }
            )
        );
    };

    const handleSaveForm = (
        event: React.FormEvent<HTMLFormElement | HTMLButtonElement>
    ) => {
        formRef.current?.onSubmit(event, true);
    };

    return (
        <Modal open maxWidth="xl" fullWidth onClose={handleClose}>
            <ModalTitle onClose={handleClose}>Activate GastroPay</ModalTitle>

            <ModalContent sx={{ p: 2 }}>
                {message && (
                    <Box mb={2}>
                        <RequestMessage message={message} status={status} />
                    </Box>
                )}
                <GastroPayForm
                    onSubmit={handleSubmit}
                    ref={formRef}
                    errors={errors}
                    loading={isLoading}
                />
            </ModalContent>
            <ModalActions>
                <Box display="flex" width="100%" textAlign="right">
                    <Button
                        onClick={handleClose}
                        color="inherit"
                        variant="text"
                        sx={{ mr: 1 }}
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        sx={{ flex: 1 }}
                        onClick={handleSaveForm}
                        loading={isLoading}
                    >
                        Save
                    </LoadingButton>
                </Box>
            </ModalActions>
        </Modal>
    );
};

export default GastroPayActivateModal;
